












































import { Badge } from '@/models';
import Vue from 'vue';

export default Vue.extend({
  name: 'BadgesItem',
  props: {
    badge: Object as () => Badge,
  },
  methods: {
    getBadgeDescriptionText(badge: Badge): string {
      return this.$t(
        `badge.types.${badge.type}.description`,
        {
          number: 'x',
        },
        ) as string;
    },
  },
});
